export default "__VITE_ASSET__CpYiDZIC__"